import { useQuery } from "@tanstack/react-query";
import { useApi } from "../../../utils";
import { ArticleDetailDto, NewsCenterClient } from "@lib/ShiOneClient";

export default function useGetNewsArticleDetail(id: number) {
  const api = useApi(NewsCenterClient);

  const getNewsArticles = async (id: number) => {
    return await api.getNewsCenterDetail(id);
  };

  return useQuery<ArticleDetailDto>({
    queryKey: ["message-center-article", id],
    queryFn: () => getNewsArticles(id),
  });
}
